import * as moment from "moment";

const quickJournalSystemClockStorageKey =
    "quickJournal_systemDateTimeOverride";
export const QuickJournalSystemClockEventName =
    "quickjournal-system-clock-changed";

export function GetQuickJournalNow(): Date {
    const overrideText = GetQuickJournalSystemDateTimeOverride();

    if (!overrideText) {
        return new Date();
    }

    const overrideDate = new Date(overrideText);

    if (Number.isNaN(overrideDate.getTime())) {
        return new Date();
    }

    return overrideDate;
}

export function GetQuickJournalCurrentTimeStamp(): string {
    return moment(GetQuickJournalNow()).format("HHmm");
}

export function GetQuickJournalSystemDateTimeOverride(): string {
    if (typeof window === "undefined") {
        return "";
    }

    const searchParams = new URLSearchParams(window.location.search);
    const queryOverride = searchParams.get("quickJournalSystemDateTime") ?? "";

    if (queryOverride) {
        const parsedQueryDate = new Date(queryOverride);

        if (!Number.isNaN(parsedQueryDate.getTime())) {
            return parsedQueryDate.toISOString();
        }
    }

    if (typeof localStorage === "undefined") {
        return "";
    }

    try {
        return localStorage.getItem(quickJournalSystemClockStorageKey) ?? "";
    } catch {
        return "";
    }
}

export function SetQuickJournalSystemDateTimeOverride(
    overrideText: string
): void {
    if (typeof localStorage === "undefined") {
        return;
    }

    if (!overrideText) {
        localStorage.removeItem(quickJournalSystemClockStorageKey);
        NotifyQuickJournalSystemClockChanged();
        return;
    }

    const parsedDate = new Date(overrideText);

    if (Number.isNaN(parsedDate.getTime())) {
        return;
    }

    localStorage.setItem(
        quickJournalSystemClockStorageKey,
        parsedDate.toISOString()
    );
    NotifyQuickJournalSystemClockChanged();
}

export function AdjustQuickJournalSystemDateTime(
    amount: moment.DurationInputArg1,
    unit: moment.unitOfTime.DurationConstructor
): void {
    const currentDate = GetQuickJournalNow();
    const nextDate = moment(currentDate).add(amount, unit).toDate();
    SetQuickJournalSystemDateTimeOverride(nextDate.toISOString());
}

export function ClearQuickJournalSystemDateTimeOverride(): void {
    SetQuickJournalSystemDateTimeOverride("");
}

export function NotifyQuickJournalSystemClockChanged(): void {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new Event(QuickJournalSystemClockEventName));
}
